import { getGameIcon } from '@/lib/gameConfig';
import { cn } from '@/lib/utils';

interface GameIconProps {
  gameCode: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizes = {
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
  lg: 'h-12 w-12',
};

const iconSizes = {
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-6 w-6',
};

export function GameIcon({ gameCode, size = 'md', className }: GameIconProps) {
  const Icon = getGameIcon(gameCode);

  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-xl bg-primary/10 text-primary',
        sizes[size],
        className
      )}
    >
      <Icon className={iconSizes[size]} />
    </div>
  );
}
